import { FC, ReactElement, useEffect, useState } from 'react'
import { AButton } from 'views/components/Analytics'
import { SampleDetailed, SampleStatus, SampleWithRequests } from '../types'
import { useTranslation } from 'react-i18next'
import { PrevPublishedToLocalModal } from 'views/pages/Bid/BidDetail/Bid/Samples/PublishSample/PublishToLocal/PrevPublishedToLocalModal'
import { PublishToLocalModal } from 'views/pages/Bid/BidDetail/Bid/Samples/PublishSample/PublishToLocal/PublishToLocalModal'

type Props = {
  sample: SampleDetailed | SampleWithRequests
  onSucess: () => Promise<void>
}

export const PublishToLocalWrapper: FC<Props> = ({ sample, onSucess }) => {
  const { t } = useTranslation('samples')
  const [showLocalModal, setShowLocalModal] = useState(false)
  const [showHistoryData, setShowHistoryData] = useState(false)

  useEffect(() => {
    if (!sample) return
    setShowHistoryData(!!sample.sent_to_local_bot_date)
  }, [sample])

  if (!sample) return <></>

  const onClose = () => {
    setShowLocalModal(false)
    setShowHistoryData(!!sample.sent_to_local_bot_date)
  }

  let btn: ReactElement | null = null
  if (sample.can_be_send_to_local_bot) {
    const text = t('sendToLocalChat')
    btn = (
      <AButton id="sendToLocalChat" color="secondary" size="medium" onClick={() => setShowLocalModal(true)}>
        {text}
      </AButton>
    )
  } else if (sample.status == SampleStatus.published && sample.cant_be_send_to_local_bot_reason) {
    btn = (
      <AButton id="sendToLocalChatPlaceholder" color="secondary" size="medium" disabled>
        {sample.cant_be_send_to_local_bot_reason}
      </AButton>
    )
  }
  return (
    <>
      {btn}
      {showLocalModal &&
        (showHistoryData ? (
          <PrevPublishedToLocalModal
            sample={sample}
            onSuccess={onSucess}
            onClose={onClose}
            setShowHistoryData={setShowHistoryData}
          />
        ) : (
          <PublishToLocalModal sample={sample} onSuccess={onSucess} onClose={onClose} />
        ))}
    </>
  )
}
